import React, { useRef } from "react";
import "./ContactPage.css";
import { Link } from "react-router-dom";
import {
  faLocationCrosshairs,
  faMobilePhone,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { faEnvelopeOpen } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import emailjs from "emailjs-com";

function ContactPage() {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_laeao7i", // Your EmailJS Service ID
        "template_xzdmcbo", // Your EmailJS Template ID
        form.current,
        "AUIleiisXWp33pdW4", // Your EmailJS Public Key
      )
      .then(
        (result) => {
          alert("Message sent successfully!");
          form.current.reset();
        },
        (error) => {
          alert("Failed to send message. Please try again.");
        },
      );
  };

  return (
    <section className="ContactPage">
      {/* TOP BANNER */}
      <div className="contact_banner">
        <div className="contact_banner_overlay">
          <h1>Contact Us</h1>
          <p>
            <Link to={"/"}>Home</Link> / Contact Us
          </p>
        </div>
      </div>

      {/* MAP SECTION */}
      <div className="contact_map">
        <iframe
          title="map"
          src="https://maps.google.com/maps?width=600&height=400&hl=en&q=17%C2%B045'08.5%22N%2073%C2%B045'14.0%22E&t=&z=14&ie=UTF8&iwloc=B&output=embed"
          loading="lazy"
          allowFullScreen
        ></iframe>
      </div>

      {/* MAIN DETAILS SECTION */}
      <div className="contact_main_section">
        {/* CONTACT DETAILS */}
        <div className="contact_details">
          <h3>Contact</h3>

          <p className="contact_icon_text">
            <span className="icon">
              <FontAwesomeIcon icon={faLocationCrosshairs} />
            </span>
            At Post Tetali Tal. Jawali Dist. Satara. (New Mahabaleshwar)
          </p>

          <p className="contact_icon_text">
            <span className="icon">
              <FontAwesomeIcon icon={faPhone} />
            </span>
            9404320245 / 9011550390
          </p>

          <p className="contact_icon_text">
            <span className="icon">
              <FontAwesomeIcon icon={faEnvelopeOpen} />
            </span>
            hoteljaltaaraa@gmail.com
          </p>
        </div>

        {/* TIMINGS */}
        <div className="contact_timings">
          <h3>Our Timings</h3>

          <p>
            At Jaltaara check out is 12 noon. Avail our early bird offer when
            you book in advance.
          </p>

          <ul>
            <li>
              <strong>Sunday :</strong> 09:00 pm – 8:00 am
            </li>
            <li>
              <strong>Monday :</strong> 10:00 pm – 5:00 am
            </li>
            <li>
              <strong>Tuesday :</strong> 10:00 pm – 5:00 am
            </li>
            <li>
              <strong>Wednesday :</strong> 10:00 pm – 5:00 am
            </li>
            <li>
              <strong>Thursday :</strong> 10:00 pm – 5:00 am
            </li>
            <li>
              <strong>Friday :</strong> 09:00 pm – 8:00 am
            </li>
            <li>
              <strong>Saturday :</strong> 10:00 pm – 5:00 am
            </li>
          </ul>
        </div>

        {/* CONTACT FORM */}
        <div className="contact_form">
          <h3>Send Us Message</h3>
          <p className="form_intro">
            Yes, I am interested. I want to stay during the winter season.
          </p>

          <form ref={form} onSubmit={sendEmail}>
            <input type="text" placeholder="Name" name="name" required />

            <input type="email" placeholder="Email" name="email" required />

            <input type="text" placeholder="Phone" name="phone" required />

            <textarea placeholder="Message" name="message" required></textarea>

            <button className="submit_btn" type="submit">
              SUBMIT
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}

export default ContactPage;
